import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { supabase } from "./supabaseClient";
import RayBassLeaderboard from "./RayBassLeaderboard";
import { buildRayBassLeaderboard, huntDateRange, isRayBassHuntActive } from "./rayBassHunt";

export default function RayBassHuntTeaser() {
  const [entries, setEntries] = useState([]);
  const huntYear = new Date().getFullYear();

  useEffect(() => {
    if (!isRayBassHuntActive()) return;

    const { start, end } = huntDateRange(huntYear);
    supabase
      .from("catches")
      .select("*")
      .eq("location", "shore")
      .gte("weigh_date", start)
      .lte("weigh_date", end)
      .then(({ data }) => setEntries(buildRayBassLeaderboard(data ?? [], huntYear)));
  }, [huntYear]);

  if (entries.length === 0) return null;

  return (
    <section className="bg-slate-950 px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto max-w-7xl">

        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-400/10 text-emerald-300">
              <Trophy className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.3em] text-emerald-300">Ray and Bass Hunt</p>
              <h2 className="text-2xl font-bold tracking-tight text-white">October {huntYear} Leaders</h2>
            </div>
          </div>
          <Link
            to="/ray-bass-hunt"
            className="inline-flex items-center gap-2 rounded-xl border border-emerald-400/30 bg-emerald-400/10 px-4 py-2.5 text-sm font-semibold text-emerald-300 transition hover:bg-emerald-400/20 hover:text-white"
          >
            View full leaderboard →
          </Link>
        </div>

        <RayBassLeaderboard entries={entries.slice(0, 3)} />

        <p className="mt-4 text-center text-xs text-slate-500">
          Best combined CFSA specimen % of one ray and one bass · Shore only
        </p>
      </div>
    </section>
  );
}
